export default __webpack_public_path__ + "static/news9-844c129638bd35557b03293ccdc4d7c6.jpeg";